import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Sparkles, RefreshCcw, Home } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function ErrorPage() {
        const { t } = useTranslation();
        // const error = useRouteError();

    // useEffect(() => {
    //     const date = new Date().toISOString();

    //     if (!window.location.href.includes("localhost")) {
    //         fetch("https://api.converty.shop/api/v1/report", {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify({
    //                 message: (error as any)?.message || "Unknown error",
    //                 stack: (error as any)?.stack || "Unknown stack",
    //                 createdAt: date,
    //                 source: window.location.href,
    //                 userAgent: navigator.userAgent,
    //                 project: "admin-frontend",
    //                 severity: "medium",
    //             }),
    //         });
    //     }

    //     // This will auto reload the page after 5 seconds one time
    //     if (!localStorage.getItem("lastReload")) {
    //         localStorage.setItem("lastReload", date);
    //         setTimeout(() => window.location.reload(), 3000);
    //     } else {
    //         const lastReload = new Date(localStorage.getItem("lastReload") as string);
    //         const now = new Date();
    //         if (now.getTime() - lastReload.getTime() > 300000) {
    //             localStorage.setItem("lastReload", date);
    //             setTimeout(() => window.location.reload(), 3000);
    //         }
    //     }
    // }, []);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground p-6">
      <img src="/assets/logo-1.png" alt="Junet Logo" className="w-48 mb-6" />
      <Card className="max-w-md w-full text-center animate-fade-in">
        <CardContent className="space-y-4 py-6">
          <Sparkles className="w-12 h-12 mx-auto text-muted-foreground animate-pulse" />
          <h1 className="text-2xl font-bold">{t("error.somethingWrong")}</h1>
          <p className="text-muted-foreground">
            {t("error.aiHasBadDays")}
          </p>
          <p className="text-sm text-muted-foreground italic">
            {t("error.abstractReasoning")}
          </p>

          <div className="flex flex-col gap-2 pt-4">
            <Button variant="default" onClick={() => window.location.reload()}>
              <RefreshCcw className="w-4 h-4 mr-2" /> {t("error.reloadPage")}
            </Button>
            <Button variant="secondary" asChild>
              <a href="/">
                <Home className="w-4 h-4 mr-2" /> {t("error.goToHomepage")}
              </a>
            </Button>
          </div>

          <div className="pt-6 text-xs text-muted-foreground border-t mt-6">
            <p>{t("error.unknownInput")}</p>
            <p>{t("error.attemptedReasoning")}</p>
            <p>{t("error.recoveryEta")}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}